import React from "react";
import { Input } from "../ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Field, US_STATES } from "./checkoutUtils";

export const PersonalInfoSection = ({ form, set, setForm }) => (
  <section className="bg-white rounded-3xl border border-slate-200 p-7 shadow-sm">
    <h2 className="font-display text-xl font-bold text-knight-navy mb-1">Personal Information</h2>
    <p className="text-xs text-knight-navy/55 mb-5">We need this information to process your credit-repair request.</p>
    <div className="grid sm:grid-cols-2 gap-4">
      <Field label="First Name *"><Input value={form.firstName} onChange={set("firstName")} placeholder="Jane" data-testid="checkout-first-name" /></Field>
      <Field label="Last Name *"><Input value={form.lastName} onChange={set("lastName")} placeholder="Doe" data-testid="checkout-last-name" /></Field>
      <Field label="Email Address *"><Input type="email" value={form.email} onChange={set("email")} placeholder="jane@example.com" data-testid="checkout-email" /></Field>
      <Field label="Phone Number *"><Input value={form.phone} onChange={set("phone")} placeholder="(555) 123-4567" data-testid="checkout-phone" /></Field>
      <Field label="Address *" wide><Input value={form.address} onChange={set("address")} placeholder="123 Main St" data-testid="checkout-address" /></Field>
      <Field label="City *"><Input value={form.city} onChange={set("city")} placeholder="Cincinnati" data-testid="checkout-city" /></Field>
      <Field label="State *">
        <Select value={form.state} onValueChange={(v) => setForm(f => ({ ...f, state: v }))}>
          <SelectTrigger data-testid="checkout-state"><SelectValue placeholder="Select state" /></SelectTrigger>
          <SelectContent>{US_STATES.map(([code, name]) => <SelectItem key={code} value={code}>{name}</SelectItem>)}</SelectContent>
        </Select>
      </Field>
      <Field label="ZIP Code *"><Input value={form.zip} onChange={set("zip")} placeholder="45202" data-testid="checkout-zip" /></Field>
    </div>
  </section>
);
